import { Redirect } from 'app/routx-router'

const RedirectToPlotsOrLogin = () => {
  return <Redirect to='/farms' replace />
}

export default RedirectToPlotsOrLogin
